module.exports = __webpack_public_path__ + "img/404.e1042c99.png";